import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../services/shared.service';
import { Router } from '@angular/router';
import { IncidentReportService } from '../services/incident-report.service';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';

/** Display like "3 / 9 / 2026" (spaces around slashes); parse accepts the same. */
export const INCIDENT_REPORT_LIST_DATE_FORMATS = {
  parse: { dateInput: 'M/d/yyyy' },
  display: {
    dateInput: 'M/d/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'M/d/yyyy',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};

export class IncidentReportListNativeDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (!date) {
      return '';
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    return m + ' / ' + d + ' / ' + y;
  }

  parse(value: any): Date | null {
    if (typeof value === 'string' && value.length) {
      var parts = value.split('/').map(function (p) { return (p || '').trim(); });
      if (parts.length === 3) {
        var m = Number(parts[0]);
        var d = Number(parts[1]);
        var y = Number(parts[2]);
        if (!isNaN(y) && !isNaN(m) && !isNaN(d)) {
          return new Date(y, m - 1, d);
        }
      }
    }
    return super.parse(value);
  }
}

@Component({
  selector: 'app-incident-report',
  templateUrl: './incident-report.component.html',
  styleUrls: ['./incident-report.component.css'],
  providers: [
    { provide: DateAdapter, useClass: IncidentReportListNativeDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: INCIDENT_REPORT_LIST_DATE_FORMATS }
  ]
})
export class IncidentReportComponent implements OnInit {
  
  

  constructor(private sharedService: SharedService,
    private router: Router,
    private incidentReport: IncidentReportService,
    private datepipe: DatePipe  ) { }

  @ViewChild('closebutton', { static: false }) closebutton;
  @ViewChild('closebuttonReopen', { static: false }) closebuttonReopen;

  errorMessage: string;
  showErrorMessage: boolean;
  showSuccessMessage: boolean;
  status: any[];
  listIncidentReport: any[] = [];
  statusId: number;
  patientId: number;
  incidentReportId: number;
  dateStartIncidentReport: any;
  dateEndIncidentReport: any;
  /** When set to a positive number, list loads that report only (dates ignored for the main query). */
  searchIncidentReportIdFilter: string = '';


  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.showSuccessMessage = false;
    this.loadDate();
    this.loadStatus();
    this.statusId = 1;
    this.patientId = 0;
    if (this.sharedService.facilityId > 0) {
      this.loadIncidentReport();
    }
  }

  loadDate() {
    this.dateEndIncidentReport = new Date();
    this.dateStartIncidentReport = new Date();
    this.dateStartIncidentReport.setDate(this.dateStartIncidentReport.getDate() - 30);
  }

  validateDate(): string[] {
    var errors: string[] = [];
    if (this.dateEndIncidentReport < this.dateStartIncidentReport)
      errors.push("The End Date must be greater then Start Date!")

    return errors;
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }

  loadStatus() {
    this.incidentReport.getStatus().subscribe(data => {
      this.status = data;
    })
  }

  openNewIncidentReport() {
    if (this.sharedService.facilityId > 0) {
      this.router.navigate(['/incident-report/create']);
    } else {
      this.showErrorMessage = true;
      this.errorMessage = "Missing select facility.";
      window.scroll(0, 0);
    }
  }

  onActionChangeFacility() {
    this.loadIncidentReport();
  }

  onActionFacilityUnit() {
    this.loadIncidentReport();
  }


  onActionChangeDate() {
    this.showErrorMessage = false;
    var resultFieldsValidation = this.validateDate();
    if (resultFieldsValidation.length == 0) {
      this.loadIncidentReport();
    }
    else {
      this.loadErrorMessage(resultFieldsValidation.join(" "));
    }
    
  }

  loadIncidentReport() {
    var dateStartCoverted = new Date(Date.parse(this.dateStartIncidentReport.toString()));
    var dateStart = this.datepipe.transform(dateStartCoverted, 'yyyy-MM-dd');
    var dateEndCoverted = new Date(Date.parse(this.dateEndIncidentReport.toString()));
    var dateEnd = this.datepipe.transform(dateEndCoverted, 'yyyy-MM-dd');

    var idFilter = 0;
    if (this.searchIncidentReportIdFilter != null && this.searchIncidentReportIdFilter.toString().trim() !== '') {
      var parsed = parseInt(this.searchIncidentReportIdFilter.toString().trim(), 10);
      if (!isNaN(parsed) && parsed > 0) {
        idFilter = parsed;
      }
    }

    this.incidentReport.getIncidentReportsByStatusId(this.sharedService.getUserId(), this.sharedService.facilityId, this.sharedService.pharmacyId, this.statusId, this.sharedService.facilityUnitId, this.patientId, idFilter, dateStart, dateEnd )
      .subscribe(data => {
      this.listIncidentReport = data;
    });
  }

  onActionStatus() {
   this.loadIncidentReport();   
  }

  clearReportIdSearch() {
    this.searchIncidentReportIdFilter = '';
    this.loadIncidentReport();
  }

  openReview(row) {
    if (!row || !row.accessKey || row.incidentReportId == null) {
      return;
    }
    this.router.navigate(['/incident-report/review', row.accessKey, row.incidentReportId]);
  }

  setIncidentReportId(id) {
    this.incidentReportId = id;
  }

  removeIncidentReport() {
    var id = this.incidentReportId;
    this.incidentReport.removeIncidentReport(id).subscribe(data => {
      this.errorMessage = "Item removed";
      this.showSuccessMessage = data;
      this.closebutton.nativeElement.click();
      this.loadIncidentReport();
      window.scroll(0, 0);
      this.incidentReportId = null;
    });
  }

  onReopenIncidentReport() {
    this.incidentReport.reopenIncidentReport(this.sharedService.getUserId(), this.incidentReportId).subscribe(data => {
      if (data.success) {
        this.errorMessage = data.data;
        this.showSuccessMessage = data.success;
        this.closebuttonReopen.nativeElement.click();
        this.loadIncidentReport();
      } else {
        this.loadErrorMessage(data.data);
      }
      window.scroll(0, 0);
      this.incidentReportId = null;
    });
  }
}
